import React from "react";

function Getlocation() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        margin: 0,
        padding: 0,
        zIndex: 9999,
      }}
    >
      <img
        src="http://footprintapps.in/ag_home_decor/clickhear_new.png"
        alt="Click Here"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover", // Or use 'contain' if you want full visibility with potential background space
        }}
      />
    </div>
  );
}

export default Getlocation;
